import React, { useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
} from "react-native";
//import FastImage from 'react-native-fast-image';
import { SvgUri } from "react-native-svg";
import { connect } from "react-redux";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";

const ClubLiveCloseCard = ({ clubDetails, isLive }) => {
  return (
    <View
      style={[globalStyle.cardContainer, { backgroundColor: Colors.bgWhite }]}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View
          style={[
            styles.marketImgStyle,
            { backgroundColor: Colors.grey5, marginRight: 12 },
          ]}
        >
          <SvgUri width="30" height="30" uri={clubDetails.image_url} />
        </View>

        <Text numberOfLines={2} style={{ flex: 1 }}>
          {clubDetails?.title}
        </Text>
      </View>
      <View style={{ marginTop: 20 }}>
        <View style={{ flexDirection: "row", marginBottom: 15 }}>
          <Text style={[styles.colStyle, styles.headerCol]}>Outcome</Text>
          <Text style={[styles.colStyle, styles.center, styles.headerCol]}>
            Investment
          </Text>
          {isLive ? (
            <Text style={[styles.colStyle, styles.right, styles.headerCol]}>
              ROI
            </Text>
          ) : (
            <>
              <Text style={[styles.colStyle, styles.right, styles.headerCol]}>
                Returns
              </Text>
              <Text style={[styles.colStyle, styles.right, styles.headerCol]}>
                Status
              </Text>
            </>
          )}
        </View>
        <FlatList
          // ListHeaderComponent={headerCompoenent}
          scrollEnabled
          data={clubDetails?.bets}
          renderItem={({ item }) => {
            return (
              <View style={{ flexDirection: "row", marginBottom: 5 }}>
                <Text
                  style={[styles.colStyle, styles.rowTxt]}
                  numberOfLines={1}
                >
                  {item?.label}
                </Text>
                <Text style={[styles.colStyle, styles.center, styles.rowTxt]}>
                  &#8377;{item?.investment?.toFixed(2)}
                </Text>
                {isLive ? (
                  <Text
                    style={[
                      styles.colStyle,
                      styles.right,
                      styles.rowTxt,
                      globalFontStyle.appFontSubTextBold,
                      { color: Colors.blue1 },
                    ]}
                  >
                    {(item?.roi * 100)?.toFixed(2)}%
                  </Text>
                ) : (
                  <>
                    <Text
                      style={[styles.colStyle, styles.right, styles.rowTxt]}
                    >
                      &#8377;{item?.returns ? item?.returns.toFixed(2) : 0}
                    </Text>
                    <Text
                      style={[
                        styles.colStyle,
                        styles.right,
                        styles.rowTxt,
                        item?.status === "Won"
                          ? { color: Colors.green }
                          : { color: Colors.red },
                      ]}
                    >
                      {item?.status}
                    </Text>
                  </>
                )}
              </View>
            );
          }}
          keyExtractor={(item, index) => index}
          showsVerticalScrollIndicator={false}
          initialNumToRender={10}
        />
      </View>
    </View>
  );
};

export default ClubLiveCloseCard;

const styles = StyleSheet.create({
  colStyle: {
    flex: 1,
    flexBasis: 0,
  },
  headerCol: {
    ...globalFontStyle.appFontSmallText,
    lineHeight: 19,
    color: Colors.lightgrey,
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  rowTxt: {
    ...globalFontStyle.appFontSubText,
    lineHeight: 19,
    color: Colors.black,
  },
  marketImgStyle: {
    width: 35,
    height: 35,
  },
});
